module.exports = __webpack_public_path__ + "img/nsw_police_logo.85613dd8.png";